import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";

export default function WineCard({ wine }) {
  const navigate = useNavigate();

  const fmt = useMemo(
    () => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "XOF" }),
    []
  );

  const priceText = fmt.format(Number(wine?.price) || 0);
  const yearText = wine?.year ? String(wine.year) : "—";

  const handleCardClick = () => {
    navigate(`/product/${wine.id}`);
  };

  return (
    <article className="wc-card" role="button" onClick={handleCardClick} tabIndex={0}
             onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleCardClick()}>
      {/* Media */}
      <div className="wc-card-media">
        <img
          src={wine?.imageUrl || "/placeholder.png"}
          alt={wine?.name || "Vin"}
          loading="lazy"
          decoding="async"
          onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = "/placeholder.png"; }}
            style={{objectFit: "contain"}}
        />
        <div className="wc-card-price">{priceText}</div>
        {wine?.type ? <span className="wc-chip wc-chip-type">{wine.type}</span> : null}
        {wine?.category ? <span className="wc-chip wc-chip-cat">{wine.category}</span> : null}
      </div>

      {/* Infos */}
      <div className="wc-card-body">
        <h3 className="wc-card-title" title={wine?.name}>{wine?.name}</h3>
        <p className="wc-card-sub" title={wine?.region}>
          {wine?.region || "Région inconnue"} • {yearText}
        </p>

        <button
          type="button"
          className="wc-card-cta"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/product/${wine.id}`);
          }}
          aria-label={`Voir ${wine?.name}`}
        >
          Voir
        </button>
      </div>
    </article>
  );

}

